import { fetchNowPlaying } from "./feeds.js";
import { nextPollDelay } from "./polling.js";
import { ResourceStore, type ResourceState } from "./resource-store.js";
import type { NowPlaying } from "./types.js";

export type FeedNowPlaying = ResourceState<NowPlaying>;

export interface StoreOptions {
  fetcher?: (feedId: string, signal: AbortSignal) => Promise<NowPlaying>;
  now?: () => number;
}

/**
 * What each feed is playing, live.
 *
 * The feeds surface, the per-feed page, the player and the now-playing sheet all
 * read the same feed at once; without one store they would each open their own poll
 * of the same route. The cadence is a radio cadence: a track changes at a knowable
 * moment, so the poll that matters lands just after it rather than up to ten seconds
 * late (`polling.ts`).
 */
export class NowPlayingStore extends ResourceStore<NowPlaying> {
  constructor(options: StoreOptions = {}) {
    super({
      fetcher: options.fetcher ?? fetchNowPlaying,
      delay: nextPollDelay,
      ...(options.now ? { now: options.now } : {}),
    });
  }
}

export const nowPlayingStore = new NowPlayingStore();
